import { Box } from '@eatclubcode/ec-component-library';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setLogoutAction } from '../../data/actions/loginAction';

const Logout = ({ setLogout, restaurantActive }) => {
  useEffect(() => {
    setLogout(restaurantActive?.restaurant?.slug);
  }, []);

  return (
    <Box
      style={{
        margin: '25vh auto 0',
        transform: 'translateY(-50%)',
        width: 'fit-content',
      }}
    >
      Logging out....
    </Box>
  );
};

Logout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  restaurantActive: PropTypes.object.isRequired,
  setLogout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  restaurantActive: state.restaurantActive,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setLogout: setLogoutAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
